import DataTable from '../admin-panel/classes/global/DataTable';
import Select2 from '../admin-panel/classes/global/Select2';

$(document).ready(function () {
    $(".select2-city").each(function () {
        let current = $(this);
        current.css('width', '100% !important');
        current.on('select2:select', function (e) {
            let data = e.params.data;
            if($('[name="' + current.attr("name") + '_parent"]').length){
                $('[name="' + current.attr("name") + '_parent"]').val(current.find("option:selected").data(current.attr("name") + '_parent'));
            }
            if($('[name="' + current.attr("name") + '-label"]').length){
                $('[name="' + current.attr("name") + '-label"]').val(data.text);
            }
        });
        current.select2({
            language: $("html").attr("lang"),
            dropdownCssClass: "select2-" + current.attr("name"),
            ajax: {
                url: current.data('url'),
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        needle: params.term, // search term
                    };
                },
                processResults: function (data) {
                    let selectobj = $.map(data, function (v) {
                        return {
                            'text': v[current.data('text_field')],
                            'id': v[current.data('id_field')] ? v[current.data('id_field')] : v['id'],
                            'city_parent': v.city_parent,
                            'province_name': v.province_name,
                        }
                    });

                    return { results: selectobj };
                },
                cache: true,
                error: function (err) {

                }
            },
            placeholder: current.data('placeholder'),
            minimumInputLength: 2,
            allowClear: true,
            templateSelection: function (data, container) {
                $(data.element).attr('data-city_parent', data.city_parent);
                $(data.element).attr('data-province_name', data.province_name);
                // Add custom attributes to the <option> tag for the selected option
                return data.text;
            },
        });
        if($('[name="' + current.attr("name") + '-label"]').length){
            $('[name="' + current.attr("name") + '-label"]').val(current.text());
        }
    });
});

$(document).ready(function () {
    $(".select2-city").on('change', function () {
        let selected = $(this).find(':selected');
        let cityParent = $(selected).data('city_parent');
        let province = $(selected).data('province_name');
        let provinceSelectID = $(this).data('autofill_province');
        let provinceSelect = $('#' + provinceSelectID);

        if($('[name="city_parent"]').length){
            $('[name="city_parent"]').val(cityParent);
        }

        provinceSelect.off('change');
        provinceSelect.on('change', function (e) {
            if($('[name="' + $(this).attr("name") + '-label"]').length > 0){
                $('[name="' + $(this).attr("name") + '-label"]').val($(this).val());
            }
        });

        if ($(provinceSelect).find('option[value="' + province + '"]').length) {
            $(provinceSelect).val(province).trigger('change');
        } else {
            let newOption = new Option(province, province, true, true);
            $(provinceSelect).append(newOption).trigger('change');
        }
    })
});

DataTable.prototype.onCreatedRow = function(property, row, data, dataIndex) {
    let callable = {
        checkMarkedForAssign: function (row, data, dataIndex) {
            if(!window.assignToConsultantUsers || !Array.isArray(window.assignToConsultantUsers) || window.assignToConsultantUsers.length == 0) {
                return;
            }

            let checkbox = $(row).find('.assign_to_consultant-checkbox');
            if(!checkbox) {
                return;
            }

            let val = $(checkbox).val();
            $(checkbox).attr('checked', window.assignToConsultantUsers.indexOf(val) > -1);
        }
    };

    if(callable.hasOwnProperty(property)) {
        callable[property](row, data, dataIndex);
    }
}

$(document).ready(function () {
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (evt) {
        var tabHref = $(evt.target).attr("href");
        var targets = $('[data-show_on_tabs]');

        targets.each(function () {
            var tabs = $(this).data('show_on_tabs');
            if(tabs.includes(tabHref)) {
                $(this).show();
            }else{
                $(this).hide();
            }
        });
    });
});

DataTable.prototype.initFilters = function (container) {
    var prefix = container ? container + ' ' : '';

    $(prefix + '.datatable__filter--select-multi').each(function () {
        let current = $(this);
        current.select2({
            language: $("html").attr("lang"),
            allowClear: true,
            cache: true,
            debug: true,
            placeholder: current.data('placeholder'),
        });
    });

    $(document).on('change', prefix + '.datatable__filter--select-multi', function (evt, autoSelected) {
        if(autoSelected) {
            return;
        }

        let current = $(this);
        let values = $(current).val();
        let tableId = $(current).data('table_target');
        let targetTable = $('#' + tableId);
        let columnTarget = $(current).data('column_target');

        targetTable.dataTable()
            .api()
            .columns( columnTarget )
            .search( values.join('|'), true, false )
            .draw();
    });


    $(prefix + '.datatable__filter--select-multi-ajax').each(function () {
        let current = $(this);
        current.select2({
            language: $("html").attr("lang"),
            dropdownCssClass: "select2-" + current.attr("name"),
            ajax: {
                url: function (params) {
                    return current.attr('data-url');
                },
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        needle: params.term, // search term
                    };
                },
                processResults: function (data) {
                    var selectobj = $.map(data, function (v) {
                        return {
                            'text': v[current.data('text_field')],
                            'id': v[current.data('id_field')] ? v[current.data('id_field')] : v['id'],
                        }
                    });
                    return { results: selectobj };
                },
                cache: true,
                error: function (err) {

                }
            },
            placeholder: current.data('placeholder'),
            minimumInputLength: 2,
            allowClear: true
        });
    });

    $(document).on('change', prefix + '.datatable__filter--select-multi-ajax', function (evt, autoSelected) {
        if(autoSelected) {
            return;
        }

        let current = $(this);
        let values = $(current).val();
        let tableId = $(current).data('table_target');
        let targetTable = $('#' + tableId);
        let columnTarget = $(current).data('column_target');

        targetTable.dataTable()
            .api()
            .columns( columnTarget )
            .search( values.join('|'), true, false )
            .draw();
    });

    $(prefix + '.datatable__filter--select').each(function () {
        let current = $(this);

        current.select2({
            language: $("html").attr("lang"),
            allowClear: true,
            cache: true,
            debug: true,
            placeholder: current.data('placeholder'),
        });
    });

    $(document).on('change', prefix + '.datatable__filter--select', function (evt, autoSelected) {

        if(autoSelected) {
            return;
        }

        let current = $(this);
        let value = $(current).val();
        let tableId = $(current).data('table_target');
        let targetTable = $('#' + tableId);
        let columnTarget = $(current).data('column_target');

        targetTable.dataTable()
            .api()
            .columns( columnTarget )
            .search( value )
            .draw();
    });

    $(prefix + '.datatable__filter--date-range-picker').each(function () {
        let current = $(this);
        let locale = $.extend(true, {}, daterangepickerLocale, {
            format: 'DD/MM/YYYY'
        });

        let options = {
            timePicker: false,
            showDropdowns: true,
            autoUpdateInput: false,
            showWeekNumbers: true,
            linkedCalendars: false,
            alwaysShowCalendars: true,
            locale: locale
        };

        current.daterangepicker(options);

        current.on('apply.daterangepicker', function (ev, picker) {
            $(this)
                .val(picker.startDate.format(locale.format) + ' - ' + picker.endDate.format(locale.format))
                .trigger('change');
        });

        current.on('cancel.daterangepicker', function (ev, picker) {
            $(this)
                .val('')
                .trigger('change');
        });
    });

    $(document).on('change', prefix + '.datatable__filter--date-range-picker', function (evt, autoSelected) {

        if(autoSelected) {
            return;
        }

        let current = $(this);
        let value = $(current).val();
        let tableId = $(current).data('table_target');
        let targetTable = $('#' + tableId);
        let columnTarget = $(current).data('column_target');

        targetTable.dataTable()
            .api()
            .columns( columnTarget )
            .search( value )
            .draw();
    });

    $(prefix + '.datatable__filter--datetime-range-picker').each(function () {
        let current = $(this);

        let options = {
            timePicker: true,
            timePicker24Hour: true,
            timePickerIncrement: 1,
            showDropdowns: true,
            autoUpdateInput: false,
            showWeekNumbers: true,
            linkedCalendars: false,
            alwaysShowCalendars: true,
            locale: daterangepickerLocale
        };

        current.daterangepicker(options);

        current.on('apply.daterangepicker', function (ev, picker) {
            $(this)
                .val(picker.startDate.format(daterangepickerLocale.format) + ' - ' + picker.endDate.format(daterangepickerLocale.format))
                .trigger('change');
        });

        current.on('cancel.daterangepicker', function (ev, picker) {
            $(this)
                .val('')
                .trigger('change');
        });
    });

    $(document).on('change', prefix + '.datatable__filter--datetime-range-picker', function (evt, autoSelected) {

        if(autoSelected) {
            return;
        }

        let current = $(this);
        let value = $(current).val();
        let tableId = $(current).data('table_target');
        let targetTable = $('#' + tableId);
        let columnTarget = $(current).data('column_target');

        targetTable.dataTable()
            .api()
            .columns( columnTarget )
            .search( value )
            .draw();
    });

    /**
     * Date picker
     */

    $(prefix + '.datatable__filter--date-picker').each(function () {
        let current = $(this);
        let locale = $.extend(true, {}, daterangepickerLocale, {
            format: 'DD/MM/YYYY'
        });

        let options = {
            timePicker: false,
            showDropdowns: true,
            autoUpdateInput: false,
            showWeekNumbers: true,
            linkedCalendars: false,
            alwaysShowCalendars: true,
            locale: locale,
            singleDatePicker: true,
        };

        current.daterangepicker(options);

        current.on('apply.daterangepicker', function (ev, picker) {
            $(this)
                .val(picker.startDate.format(locale.format))
                .trigger('change');
        });

        current.on('cancel.daterangepicker', function (ev, picker) {
            $(this)
                .val('')
                .trigger('change');
        });
    });

    $(document).on('change', prefix + '.datatable__filter--date-picker', function (evt, autoSelected) {

        if(autoSelected) {
            return;
        }

        let current = $(this);
        let value = $(current).val();
        let tableId = $(current).data('table_target');
        let targetTable = $('#' + tableId);
        let columnTarget = $(current).data('column_target');

        targetTable.dataTable()
            .api()
            .columns( columnTarget )
            .search( value )
            .draw();
    });

    /**
     * End date picker
     */

    /**
     * Datetime picker
     */

    $(prefix + '.datatable__filter--datetime-picker').each(function () {
        let current = $(this);
        let locale = $.extend(true, {}, daterangepickerLocale, {
            format: 'DD/MM/YYYY HH:mm'
        });

        let options = {
            timePicker: true,
            timePicker24Hour: true,
            timePickerIncrement: 1,
            showDropdowns: true,
            autoUpdateInput: false,
            showWeekNumbers: true,
            linkedCalendars: false,
            alwaysShowCalendars: true,
            locale: locale,
            singleDatePicker: true,
        };

        current.daterangepicker(options);

        current.on('apply.daterangepicker', function (ev, picker) {
            $(this)
                .val(picker.startDate.format(locale.format))
                .trigger('change');
        });

        current.on('cancel.daterangepicker', function (ev, picker) {
            $(this)
                .val('')
                .trigger('change');
        });
    });

    $(document).on('change', prefix + '.datatable__filter--datetime-picker', function (evt, autoSelected) {

        if(autoSelected) {
            return;
        }

        let current = $(this);
        let value = $(current).val();
        let tableId = $(current).data('table_target');
        let targetTable = $('#' + tableId);
        let columnTarget = $(current).data('column_target');

        targetTable.dataTable()
            .api()
            .columns( columnTarget )
            .search( value )
            .draw();
    });

    /**
     * End datetime picker
     */


    let searchText = (current) => {
        let value = $(current).val();
        let tableId = $(current).data('table_target');
        let targetTable = $('#' + tableId);
        let columnTarget = $(current).data('column_target');

        targetTable.dataTable()
            .api()
            .columns( columnTarget )
            .search( value )
            .draw();
    }

    $(document).on('input', prefix + '.datatable__filter--search', function (evt, autoSelected) {
        let current = $(this);
        if(autoSelected) {
            return;
        }

        if(current.val() != '') {
            return;
        }

        searchText(current);
    });

    $('body').on('keypress', prefix + '.datatable__filter--search', function (evt, autoSelected) {
        if(autoSelected) {
            return;
        }

        if(evt.which != 13) {
            return;
        }else{
            evt.preventDefault();
        }

        let current = $(this);
        searchText(current);
    });

    let searchNumberRange = (current) => {
        let targetTable = $('#' + $(current).data('table_target'));
        let columnTarget = $(current).data('column_target');
        let min;
        let max;

        if(current.hasClass('datatable__filter--number-range_from')) {
            let maxInput = current.next('.datatable__filter--number-range_to');
            min = current.val() ? current.val() : null;
            max = maxInput.val() ? maxInput.val() : null;

            maxInput.attr('min', min);
        }else{
            let minInput = current.prev('.datatable__filter--number-range_from');
            max = current.val() ? current.val() : null;
            min = minInput.val() ? minInput.val() : null;

            minInput.attr('max', max);
        }

        targetTable.dataTable()
            .api()
            .columns( columnTarget )
            .search( min + "|" + max )
            .draw();
    };

    $('body').on('keypress', '.datatable__filter--number-range', function (evt, autoSelected) {
        if(autoSelected) {
            return;
        }

        if(evt.which != 13) {
            return;
        }else{
            evt.preventDefault();
        }

        let current = $(this);
        searchNumberRange(current);
    });

    $('body').on('input', '.datatable__filter--number-range', function (evt, autoSelected) {
        let current = $(this);

        if(autoSelected) {
            return;
        }

        if(current.val() != '') {
            return;
        }

        searchNumberRange(current);
    });
}

window.drawDataTable = function (tableId) {
    let table = $('#' + tableId);
    if(table.length) {
        if($.fn.dataTable.isDataTable(table)) {
            table.DataTable().clear().destroy();
        }

        DataTable.prototype.draw(table);
    }
};

Select2.prototype.init = function () {
    $('.select2-rendered').each(function () {
        let current = $(this);
        current.select2({
            language: $("html").attr("lang"),
            dropdownCssClass: "select2-" + current.attr("name"),
            allowClear: true,
            cache: true,
            debug: true,
            placeholder: current.data('placeholder'),
        });
    });
}

DataTable.prototype.export = function () {
    $('.btn-export-dt').click(function(evt) {
        evt.preventDefault();
        let targetTable = $(this).data('target_table');

        Swal.fire({
            text: _t('Are you sure you want to export the selected items?'),
            icon: "warning",
            buttonsStyling: false,
            showCancelButton: true,
            cancelButtonText: _t('Cancel'),
            confirmButtonText: _t('Yes'),
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-default',
            }
        }).then(function(result) {
            if(result.value) {
                let params = $('#' + targetTable).dataTable().api().ajax.params();
                let url = $('#' + targetTable).dataTable().api().ajax.url();
                let visible = $('#' + targetTable).dataTable().api().columns().visible().toArray();
                for (let column in params.columns) {
                    params.columns[column].visible = visible[column];
                }

                params.export = true;
                params.length = -1;

                $.ajax({
                    url: url,
                    method: 'POST',
                    data: params,
                    headers: {
                        'X-CSRF-TOKEN': window._token
                    },
                    success() {
                        Swal.fire({
                            html: _t("We've started exporting the selected items. You will receive an email notification when the export is complete.") + '<br/><br/><a href="/exports">' + _t('Go to Exports section') + '</a>',
                            icon: "success",
                            showCancelButton: false,
                        })
                    }
                });
            }
        });
    }) ;
}

window.isValidUrl = function (url) {
    return /^(http(s)?:\/\/)?(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(url);
}

window.parseUrl = function (str, component) { // eslint-disable-line camelcase
    //       discuss at: https://locutus.io/php/parse_url/
    //      original by: Steven Levithan (https://blog.stevenlevithan.com)
    // reimplemented by: Brett Zamir (https://brett-zamir.me)
    //         input by: Lorenzo Pisani
    //         input by: Tony
    //      improved by: Brett Zamir (https://brett-zamir.me)
    //           note 1: original by https://stevenlevithan.com/demo/parseuri/js/assets/parseuri.js
    //           note 1: blog post at https://blog.stevenlevithan.com/archives/parseuri
    //           note 1: demo at https://stevenlevithan.com/demo/parseuri/js/assets/parseuri.js
    //           note 1: Does not replace invalid characters with '_' as in PHP,
    //           note 1: nor does it return false with
    //           note 1: a seriously malformed URL.
    //           note 1: Besides function name, is essentially the same as parseUri as
    //           note 1: well as our allowing
    //           note 1: an extra slash after the scheme/protocol (to allow file:/// as in PHP)
    //        example 1: parse_url('https://user:pass@host/path?a=v#a')
    //        returns 1: {scheme: 'https', host: 'host', user: 'user', pass: 'pass', path: '/path', query: 'a=v', fragment: 'a'}
    //        example 2: parse_url('https://en.wikipedia.org/wiki/%22@%22_%28album%29')
    //        returns 2: {scheme: 'https', host: 'en.wikipedia.org', path: '/wiki/%22@%22_%28album%29'}
    //        example 3: parse_url('https://host.domain.tld/a@b.c/folder')
    //        returns 3: {scheme: 'https', host: 'host.domain.tld', path: '/a@b.c/folder'}
    //        example 4: parse_url('https://gooduser:secretpassword@www.example.com/a@b.c/folder?foo=bar')
    //        returns 4: { scheme: 'https', host: 'www.example.com', path: '/a@b.c/folder', query: 'foo=bar', user: 'gooduser', pass: 'secretpassword' }

    let query

    const mode = 'php'

    const key = [
        'source',
        'scheme',
        'authority',
        'userInfo',
        'user',
        'pass',
        'host',
        'port',
        'relative',
        'path',
        'directory',
        'file',
        'query',
        'fragment'
    ]

    // For loose we added one optional slash to post-scheme to catch file:/// (should restrict this)
    let parser = {
        php: new RegExp([
            '(?:([^:\\/?#]+):)?',
            '(?:\\/\\/()(?:(?:()(?:([^:@\\/]*):?([^:@\\/]*))?@)?([^:\\/?#]*)(?::(\\d*))?))?',
            '()',
            '(?:(()(?:(?:[^?#\\/]*\\/)*)()(?:[^?#]*))(?:\\?([^#]*))?(?:#(.*))?)'
        ].join('')),
        strict: new RegExp([
            '(?:([^:\\/?#]+):)?',
            '(?:\\/\\/((?:(([^:@\\/]*):?([^:@\\/]*))?@)?([^:\\/?#]*)(?::(\\d*))?))?',
            '((((?:[^?#\\/]*\\/)*)([^?#]*))(?:\\?([^#]*))?(?:#(.*))?)'
        ].join('')),
        loose: new RegExp([
            '(?:(?![^:@]+:[^:@\\/]*@)([^:\\/?#.]+):)?',
            '(?:\\/\\/\\/?)?',
            '((?:(([^:@\\/]*):?([^:@\\/]*))?@)?([^:\\/?#]*)(?::(\\d*))?)',
            '(((\\/(?:[^?#](?![^?#\\/]*\\.[^?#\\/.]+(?:[?#]|$)))*\\/?)?([^?#\\/]*))',
            '(?:\\?([^#]*))?(?:#(.*))?)'
        ].join(''))
    }

    const m = parser[mode].exec(str)
    const uri = {}
    let i = 14

    while (i--) {
        if (m[i]) {
            uri[key[i]] = m[i]
        }
    }

    if (component) {
        return uri[component.replace('PHP_URL_', '').toLowerCase()]
    }

    if (mode !== 'php') {
        const name = 'queryKey'
        parser = /(?:^|&)([^&=]*)=?([^&]*)/g
        uri[name] = {}
        query = uri[key[12]] || ''
        query.replace(parser, function ($0, $1, $2) {
            if ($1) {
                uri[name][$1] = $2
            }
        })
    }

    delete uri.source
    return uri
}

window.unparseUrl = function (parsedUrl) {
    let pass = parsedUrl.hasOwnProperty('pass') ? parsedUrl.pass : null;
    let user = parsedUrl.hasOwnProperty('user') ? parsedUrl.user : null;
    let userinfo = pass !== null ? user + ":" + pass : user;
    let port = parsedUrl.hasOwnProperty('port') ? parsedUrl.port : 0;
    let scheme = parsedUrl.hasOwnProperty('scheme') ? parsedUrl.scheme : "";
    let query = parsedUrl.hasOwnProperty('query') ? parsedUrl.query : "";
    let fragment = parsedUrl.hasOwnProperty('fragment') ? parsedUrl.fragment : "";
    let authority = (
        (userinfo !== null ? userinfo + "@" : "") +
        (parsedUrl.hasOwnProperty('host') ? parsedUrl.host : "") +
        (port ? ":" + port : "")
    );
    return (
        (scheme.length > 0 ? scheme + ":" : "") +
        (authority.length > 0 ? "//" + authority : "") +
        (parsedUrl.hasOwnProperty('path') ? parsedUrl.path : "") +
        (query.length > 0 ? "?" + query : "") +
        (fragment.length > 0 ? "#" + fragment : "")
    );
}

window.updateSingleField = function (route, data) {
    $.ajax({
        type: "POST",
        url: route,
        headers: {
            'X-CSRF-TOKEN': window._token
        },
        data: data,
        success: function (res) {
            if (res.success) {
                SwalToast.fire({
                    icon: 'success',
                    title: res.message
                });
            }
        },
    });
}




// WEBPACK FOOTER //
// ./resources/js/app/_global.js